// routes/ir/$cnpj/route.tsx — pass-through layout so the public IR
// page can have child routes if we ever split filings / governance later.
// Renders only the child route's element; no chrome of its own (the
// IrPageShell lives on the leaf).
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/ir/$cnpj")({
  component: IrCnpjLayoutRoute,
});

function IrCnpjLayoutRoute() {
  return <Outlet />;
}
